//THIS IS FOR THE ADMIN LOGIN CONSTANTS
export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
//FOLLOWING IS FOR THE LOGOUT BY THE ADMIN OR THE OTHER COMMON LOGGED IN TEACHERS
export const USER_LOGOUT = 'USER_LOGOUT'
//FOLLOWING ARE FOR DELETING THE STUDEN
